import { useMutation } from "react-query";
import { BACKEND_DOMAIN } from "utils/constants";
import { buildRequestHeaders, showMutationAlert } from "utils/helpers";
import { useAccessToken } from "hooks/useAccessToken";
import useAlert from "hooks/useAlert";

interface CreateBuildingsResult {
    buildingModelUid?: string;
    error?: string;
}

const useMutationCreateBuildings = (onSuccess?: (buildingModelUids: string[]) => void) => {
    const accessToken = useAccessToken();
    const alert = useAlert();

    return useMutation({
        mutationFn: async (buildingModels: any[]) => {
            const response = await fetch(`${BACKEND_DOMAIN}/buildings`, {
                method: "POST",
                headers: buildRequestHeaders(accessToken),
                body: JSON.stringify(buildingModels),
            });
            if (!response.ok) {
                throw new Error(`Error ${response.status}`);
            }
            return response.json() as Promise<CreateBuildingsResult[]>;
        },
        onSuccess: (results) => {
            console.log(results);
            if (onSuccess) {
                const buildingModelUids = results
                    .filter((r): r is { buildingModelUid: string } => !!r.buildingModelUid)
                    .map((r) => r.buildingModelUid);
                onSuccess(buildingModelUids);
            }
        },
        onError: (error) => {
            showMutationAlert(error, alert);
        },
    });
};

export default useMutationCreateBuildings;
